import { Star, Time, UserMultiple } from "@carbon/icons-react";
import cx from "classnames";
import { NavLink, Outlet } from "react-router-dom";

import SubNav from "@/components/layout/SubNav/SubNav";
import { Badge } from "@/components/ui/badge";

import { FriendsPathsEnum } from "../constants/friends";

const navLinks = [
  {
    url: FriendsPathsEnum.MY_FRIENDS,
    end: true,
    icon: <UserMultiple size={18} />,
    label: "Bạn bè",
    badge: null,
    description: "Danh sách bạn bè của bạn",
  },
  {
    url: FriendsPathsEnum.SUGGESTIONS,
    end: true,
    icon: <Star size={18} />,
    label: "Gợi ý",
    badge: null,
    description: "Những người bạn có thể quen",
  },
  {
    url: FriendsPathsEnum.REQUEST_FRIENDS,
    end: true,
    icon: <Time size={18} />,
    label: "Lời mời",
    badge: "3",
    description: "Quản lý lời mời kết bạn",
  },
];

const DefaultLayout = () => {
  return (
    <div className="min-h-screen bg-secondary-25">
      <SubNav>
        <div className="w-full h-full flex flex-col">
          {/* Navigation Section */}
          <div className="flex-1 p-4 bg-white">
            <div className="space-y-2">
              {navLinks.map((navLink, index) => (
                <NavLink
                  key={index}
                  to={navLink.url}
                  end={navLink.end}
                  className={({ isActive }) =>
                    cx(
                      "group flex items-center justify-between px-3 py-3 rounded-xl transition-all duration-200",
                      isActive
                        ? "bg-primary-50 text-primary-700 shadow-sm"
                        : "text-secondary-700 hover:bg-secondary-50"
                    )
                  }
                >
                  {({ isActive }) => (
                    <>
                      <div className="flex items-center space-x-3">
                        <div
                          className={cx(
                            "w-8 h-8 rounded-lg flex items-center justify-center transition-colors",
                            isActive
                              ? "bg-primary-100"
                              : "bg-secondary-100 group-hover:bg-secondary-200"
                          )}
                        >
                          <div
                            className={cx(
                              isActive
                                ? "text-primary-600"
                                : "text-secondary-600"
                            )}
                          >
                            {navLink.icon}
                          </div>
                        </div>
                        <div className="flex flex-col">
                          <span className="font-medium">{navLink.label}</span>
                          <span className="text-xs text-secondary-500">
                            {navLink.description}
                          </span>
                        </div>
                      </div>
                      {navLink.badge && (
                        <Badge
                          variant="secondary"
                          className="bg-red-100 text-red-700 text-xs px-2 py-1"
                        >
                          {navLink.badge}
                        </Badge>
                      )}
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </SubNav>

      {/* Main Content */}
      <div className="content pl-[280px]  min-h-screen bg-secondary-25">
        <Outlet />
      </div>
    </div>
  );
};

export default DefaultLayout;
